// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#article-comment .link{color:#386ff2;margin:0 4px;cursor:pointer}#article-comment .link .link+.link,#article-comment .link:first-child{margin-left:0}#article-comment .link i{font-size:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
